import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Send } from "lucide-react";

function FormContactUs() {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const mailtoLink = `mailto:info@twhmenu.com?subject=${encodeURIComponent(
      subject
    )}&body=Name: ${encodeURIComponent(name)}%0APhone: ${encodeURIComponent(
      phone
    )}%0AMessage: ${encodeURIComponent(message)}`;

    window.location.href = mailtoLink;
  };

  const inputStyle = "w-full border-2 border-border rounded-lg px-4 py-3 bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-MainBlue focus:border-transparent transition-all duration-300";

  return (
    <div className="flex flex-col w-full">
      <form className="flex flex-col gap-4 md:gap-5" onSubmit={handleSubmit}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
        >
          <input
            type="text"
            className={inputStyle}
            placeholder={t("contact.name")}
            value={name}
            onChange={(e: any) => setName(e.target.value)}
            required
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <input
            type="tel"
            className={inputStyle}
            placeholder={t("contact.phone")}
            value={phone}
            onChange={(e: any) => setPhone(e.target.value)}
            required
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.2 }}
        >
          <input
            type="text"
            className={inputStyle}
            placeholder={t("contact.subject")}
            value={subject}
            onChange={(e: any) => setSubject(e.target.value)}
            required
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.3 }}
        >
          <textarea
            className={`${inputStyle} resize-none min-h-[120px] md:min-h-[150px]`}
            placeholder={t("contact.message")}
            value={message}
            onChange={(e: any) => setMessage(e.target.value)}
            required
          ></textarea>
        </motion.div>

        <motion.button
          type="submit"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.4 }}
          className="w-full bg-gradient-to-r from-MainBlue to-blue-600 hover:from-blue-600 hover:to-MainBlue text-white rounded-lg px-6 py-3 md:py-4 font-semibold text-base md:text-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          <span>{t("contact.send")}</span>
          <Send className="w-5 h-5" />
        </motion.button>
      </form>
    </div>
  );
}

export default FormContactUs;
